(function () {
  var STORAGE_KEY = 'seulab_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function toggleWishlist(data) {
    var items = getWishlist();
    var index = items.findIndex(function (item) { return String(item.id) === String(data.id); });
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(data);
    }
    saveWishlist(items);
    return index === -1;
  }

  function refreshHeartButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = isInWishlist(btn.getAttribute('data-product-id'));
      btn.setAttribute('data-active', active ? 'true' : 'false');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();

    var data = {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url')
    };

    var added = toggleWishlist(data);
    document.querySelectorAll('[data-wishlist-toggle][data-product-id="' + data.id + '"]').forEach(function (el) {
      el.setAttribute('data-active', added ? 'true' : 'false');
      el.setAttribute('aria-pressed', added ? 'true' : 'false');
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Ekleniyor...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('input[name="id"]').value, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        button.textContent = 'Eklendi ✓';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        showToast('Ürün sepete eklendi');
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = 'Hata, tekrar dene';
        button.disabled = false;
      });
  });

  function showToast(message) {
    var toast = document.querySelector('.product-card__toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'product-card__toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.setAttribute('data-visible', 'true');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.setAttribute('data-visible', 'false');
    }, 1800);
  }

  document.addEventListener('DOMContentLoaded', refreshHeartButtons);
  document.addEventListener('wishlist:updated', refreshHeartButtons);

  window.SeulabWishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    isSaved: isInWishlist
  };
})();
